import Footer from "@/components/footer";
import Navbar from "@/components/navbar";
import ProjectCard from "@/components/project-card";

const PROJECTS = [
  {
    title: "Realtime Collaboration Board",
    description:
      "A WebSocket-driven whiteboard enabling multiplayer sketching, sticky notes, and cursors.",
    image:
      "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["React", "WebSockets", "Hono", "Drizzle"],
    link: "#",
    repo: "#",
  },
  {
    title: "Design System for SaaS",
    description: "Composable component library based on Radix and Tailwind.",
    image:
      "https://images.pexels.com/photos/3861957/pexels-photo-3861957.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["Design System", "Accessibility", "Radix"],
    link: "#",
  },
  {
    title: "Analytics Dashboard",
    description: "Server-rendered metrics using edge functions, charts, and caching.",
    image:
      "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["Edge", "Charts", "Caching"],
    link: "#",
  },
  {
    title: "E-commerce Starter",
    description: "Headless commerce with Stripe, webhooks, and admin.",
    image:
      "https://images.pexels.com/photos/7567440/pexels-photo-7567440.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["Stripe", "Next.js", "Prisma"],
    link: "#",
  },
];

export default function Projects() {
  return (
    <div>
      <Navbar />
      <main className="mx-auto max-w-6xl px-4 sm:px-6 py-16">
        <h1 className="text-3xl font-semibold tracking-tight">Projects</h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">
          Real-world work from product design to full-stack engineering. I prioritize accessibility,
          performance, and developer experience.
        </p>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((p) => (
            <ProjectCard key={p.title} project={p} />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
